import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Route } from '@app/core/route.service';
import { DeviceGroupsComponent } from './device-groups.component';

const routes: Routes = Route.withShell([
  { path: 'devicegroups', component: DeviceGroupsComponent, data: { title: 'Device Groups' } }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeviceGroupsRoutingModule { }
